const Grade = {

    // FIELDS
    "name": "الاسم",
    "description": "الوصف",
    "search": "البحث",

    // PAGE HEADER
    "grade": "الدرجة",

    // ERROR
    "error_name": "الرجاء إدخال الاسم",
    "error_desc": "الرجاء إدخال الوصف",

    // TABLE HEADER
    "table_name": 'الاسم',
    "table_description": "الوصف",

}

export default Grade;